export class CoordinatesEntity {
  'page': number;
  'posX': number;
  'posY': number;
}
